import { MouseEvent, useState } from 'react';

// eslint-disable-next-line no-restricted-imports
import { ClickAwayListener } from '@mui/material';
import { Stack } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';

import { HintStyled, TooltipStyled, TypographyStyled } from './Hint.styles';
import { HintProps } from './types';

/**
 * Hint component.
 */
export const Hint = ({ title }: HintProps) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setOpen(true);
  };

  const preparedTitle =
    typeof title === 'string' ? (
      <TypographyStyled className="tooltip-typography" variant="caption">
        {title}
      </TypographyStyled>
    ) : (
      title
    );

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Stack alignItems="center" direction="row">
        <TooltipStyled
          arrow
          open={open}
          placement="bottom"
          title={preparedTitle}
          type="click"
          onClose={handleTooltipClose}
        >
          <HintStyled onClick={handleTooltipOpen}>
            <Icon.Info className="hint-info" size={16} />
          </HintStyled>
        </TooltipStyled>
      </Stack>
    </ClickAwayListener>
  );
};
